import * as Yup from 'yup';

import { jobSearchStatusesOptions as defaultJobSearchStatusOptions } from '../../../defaultFilters';

export const useSignupJobSearchStatusFilter = ({ setFilters }) => {
  const jobSearchStatusOptions = defaultJobSearchStatusOptions;

  const formSchema = Yup.object().shape({
    signupJobSearchStatuses: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSubmit = ({ signupJobSearchStatuses }) => {
    setFilters({ signupJobSearchStatuses });
  };

  return {
    formSchema,
    onSubmit,
    jobSearchStatusOptions,
  };
};
